import type { Router } from 'vue-router';

// Depois de um deploy, uma aba aberta antes dele ainda tem o index antigo e pede chunks com hash que
// não existem mais; o servidor devolve o index.html e o import da rota falha ("Failed to fetch
// dynamically imported module" / MIME text/html). Sem isto o clique em "Abrir" simplesmente não navega.
// Recarrega uma vez direto na rota pedida; a janela evita loop se o chunk novo também falhar.
const RELOAD_KEY = 'almada:chunk-reload-at';
const RELOAD_WINDOW_MS = 10_000;

const CHUNK_ERROR =
	/Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Expected a JavaScript module script/i;

export function isChunkLoadError(error: unknown): boolean {
	const message = error instanceof Error ? error.message : String(error ?? '');
	return CHUNK_ERROR.test(message);
}

export function shouldReload(now: number, storage: Pick<Storage, 'getItem' | 'setItem'>): boolean {
	try {
		const last = Number(storage.getItem(RELOAD_KEY) ?? 0);
		if (now - last < RELOAD_WINDOW_MS) return false;
		storage.setItem(RELOAD_KEY, String(now));
	} catch {
		// sessionStorage bloqueado: recarrega mesmo assim (no pior caso, uma vez por clique).
	}
	return true;
}

// Só recarrega dentro da própria origem: um caminho como "//outro-host" viraria redirecionamento aberto.
export function sameOriginTarget(fullPath: string, origin: string): string | null {
	try {
		const url = new URL(fullPath, origin);
		return url.origin === origin ? url.href : null;
	} catch {
		return null;
	}
}

export function installChunkReload(router: Router): void {
	router.onError((error, to) => {
		if (!isChunkLoadError(error)) return;
		if (!shouldReload(Date.now(), window.sessionStorage)) return;
		const target = sameOriginTarget(to.fullPath, window.location.origin);
		if (target) window.location.assign(target);
		else window.location.reload();
	});
}
